import {isCompanyAdmin, isSuperAdmin} from "../../helpers/helpers";

export const getFieldsPending = () => {
    return {
        type: 'GET_FIELDS_PENDING'
    }
};

export const getFieldsSuccess = fields => {
    return {
        type: 'GET_FIELDS_SUCCESS',
        fields
    }
};

export const getFieldsError = error => {
    return {
        type: 'GET_FIELDS_ERROR',
        error: error
    }
};

export const getFields = userId => {

    const url = userId ? `user_fields/${userId}` : 'fields';

    return dispatch => {
        dispatch(getFieldsPending());

        fetch(`${process.env.REACT_APP_API_URL}/${url}`, {
            method: "GET",
            headers: {
                'Content-Type': 'application/json; charset=UTF-8',
                'Authorization': sessionStorage.getItem('agronetToken'),
                'Local': localStorage.getItem('lang') ? localStorage.getItem('lang') : 'en'
            }
        })
            .then(res => {
                if (res.status === 200) {
                    return res.json()
                } else {
                    dispatch(getFieldsError(`Error: ${res.status} ${res.statusText}`))
                }
            })
            .then(res => {
                dispatch(getFieldsSuccess(res.fields))
            })
            .catch(err => {
                console.log('ERROR', err);
            })
    }
};

export const getAllFields = () => {

    return dispatch => {
        dispatch(getFieldsPending());

        fetch(`${process.env.REACT_APP_API_URL}/all_fields`, {
            method: "GET",
            headers: {
                'Content-Type': 'application/json; charset=UTF-8',
                'Authorization': sessionStorage.getItem('agronetToken'),
                'Local': localStorage.getItem('lang') ? localStorage.getItem('lang') : 'en'
            }
        })
            .then(res => {
                if (res.status === 200) {
                    return res.json()
                } else {
                    dispatch(getFieldsError(`Error: ${res.status} ${res.statusText}`))
                }
            })
            .then(res => {
                dispatch(getFieldsSuccess(res.fields))
            })
            .catch(err => {
                console.log('ERROR', err);
            })
    }
};

export const selectField = (field, page) => {
    return {
        type: 'SELECT_FIELD',
        selected: { field: field, page }
    };
};

export const editField = (fieldData) => {
    return dispatch => {
        dispatch(getFieldsPending());

        fetch(`${process.env.REACT_APP_API_URL}/panel/update_field_with_ranges`, {
            method: "POST",
            headers: {
                'Content-Type': 'application/json; charset=UTF-8',
                'Authorization': sessionStorage.getItem('agronetToken'),
                'Local': localStorage.getItem('lang') ? localStorage.getItem('lang') : 'en'
            },
            body: JSON.stringify(fieldData)
        })
            .then(res => {
                if (res.status === 200) {
                    isSuperAdmin() || isCompanyAdmin() ? dispatch(getAllFields()) : dispatch(getFields());
                } else {
                    dispatch(getFieldsError(`Error: ${res.status} ${res.statusText}`))
                }
            })
            .catch(err => {
                console.log('ERROR', err);
            })
    }
};
